<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<section class="page">
	<section>
		<div class="top-actions">
			<globalictcc-input
				label="Search users"
				iconName="search"
				[formControl]="searchControl"
			/>

			<globalictcc-button
				label="Add user"
				iconName="plus"
				(handleClick)="onAddNewUser()"
			/>
		</div>

		<div class="filter-pagination">
			<globalictcc-popover>
				<globalictcc-button
					popover-trigger
					label="Filter"
					[textOnly]="true"
					iconName="filter"
				/>

				<form
					popover-template
					class="popover-content"
					[formGroup]="filterForm"
				>
					<span class="popover-title">Filter</span>

					<globalictcc-dropdown
						label="Role"
						class="fill"
						[options]="rolesOptions"
						formControlName="role"
						[multi]="true"
					/>

					<globalictcc-button
						label="Apply"
						type="submit"
						(handleClick)="onFilterApply()"
					/>
				</form>
			</globalictcc-popover>

			<globalictcc-pagination
				[currentPage]="currentPage"
				[pageSize]="pageSize"
				[totalItems]="totalItems"
				[totalPages]="totalPages"
				[pageItems]="pageItems"
				(handleNextPage)="onHandleNextPage()"
				(handlePreviousPage)="onHandlePreviousPage()"
			/>
		</div>

		<globalictcc-table
			[gridOptions]="gridOptions"
			[hasError]="usersTableHasError"
			(handleTableRefresh)="onTableRefresh()"
		/>
	</section>

	<div class="bottom-actions">
		<globalictcc-button
			label="Download as CSV"
			iconName="download"
			[textOnly]="true"
		/>
	</div>
</section>

<!-- Dialogs content -->
<ng-template #newUserDialogContent>
	<form [formGroup]="newUserForm">
		<globalictcc-input
			label="Insert Name"
			formControlName="name"
			class="fill"
		/>

		<globalictcc-input
			label="Insert Surname"
			formControlName="surname"
			class="fill"
		/>

		<globalictcc-input
			label="Insert Username"
			formControlName="username"
			class="fill"
		/>

		<globalictcc-input
			label="Insert Email Address"
			formControlName="email"
			class="fill"
		/>

		<globalictcc-input
			label="Insert Description"
			formControlName="description"
			class="fill"
		/>

		<globalictcc-dropdown
			label="Role"
			formControlName="role"
			class="fill"
			[options]="rolesOptions"
		/>
	</form>
</ng-template>

<ng-template #editUserDialogContent>
	<form [formGroup]="editUserForm">
		<globalictcc-input
			label="Insert Name"
			formControlName="name"
			class="fill"
		/>

		<globalictcc-input
			label="Insert Surname"
			formControlName="surname"
			class="fill"
		/>

		<globalictcc-input
			label="Insert Username"
			formControlName="username"
			class="fill"
		/>

		<globalictcc-input
			label="Insert Email Address"
			formControlName="email"
			class="fill"
		/>

		<globalictcc-input
			label="Insert Description "
			formControlName="description"
			class="fill"
		/>

		<globalictcc-dropdown
			label="Role"
			formControlName="role"
			class="fill"
			[options]="rolesOptions"
		/>
	</form>

	<globalictcc-button
		label="Delete this user"
		[textOnly]="true"
		iconName="delete"
		iconPosition="left"
		(handleClick)="handleDelete()"
	/>
</ng-template>
